var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"is-flex is-centered"},[_c('progress',{staticClass:"progress",attrs:{"max":_vm.props.max || 100},domProps:{"value":_vm.props.value}}),_c('span',{staticClass:"label-small-gray"},[_vm._v(_vm._s(_vm.props.value)+"%")])])}
var staticRenderFns = []

export { render, staticRenderFns }